'use client';
import { ReactNode, createContext, useContext } from 'react';
import { TypeProduct } from '@/core/generated-types';
import { InventoryStatusCopy, ProductVariantCopy } from '@/lib/contentful';
import { ShopifyProduct } from '@/lib/shopify';
import { TypeProduct as InternalProduct } from '@/lib/api/productCatalog/types';

export interface ProductContextValue {
  enableYotpoReviewsSummary: boolean | null;
  enableTrustedShopsReviewsSummary: boolean | null;
  product: TypeProduct | null;
  shopifyProduct?: ShopifyProduct | null;
  inventoryStatusCopy?: InventoryStatusCopy | null;
  productVariantsCopy?: ProductVariantCopy | null;
  carouselImagePosition?: number | null;
  setCarouselImagePosition?: any;
  internalProduct?: InternalProduct | null;
}

const ProductContext = createContext({} as ProductContextValue);

interface ProductProviderProps {
  children: ReactNode;
  value: ProductContextValue;
}

export const ProductContextProvider: React.FC<ProductProviderProps> = ({
  children,
  value,
}) => {
  const productContextValue: ProductContextValue = {
    ...value,
  };

  return (
    <ProductContext.Provider value={productContextValue}>
      {children}
    </ProductContext.Provider>
  );
};

const useProductContext = () => {
  const context = useContext(ProductContext);

  if (!context) {
    throw new Error(
      'useProductContext must be used within a ProductContextProvider',
    );
  }

  return context;
};

export default useProductContext;
